<template>
	<div style="font-size: 12px; color: var(--el-color-info-light-3)">
		<el-icon style="margin-right: 6px">
			<Sunrise />
		</el-icon>
		<span>SunAdmin {{ version?.version || "获取版本号失败" }}</span>
		<el-divider direction="vertical" />
		<a href="https://gitee.com/sunjinglong" target="_blank" style="color: unset">Gitee Home</a>
		<el-divider direction="vertical" />
		<a href="https://gitee.com/sunjinglong/create-sunadmin--npm/issues" target="_blank" style="color: unset">Issue</a>
		<el-divider direction="vertical" />
		<a href="https://gitee.com/sunjinglong/create-sunadmin--npm" target="_blank" style="color: unset">开发文档</a>
	</div>
</template>

<script>
import version from "../../../../assets/version.json";
export default {
	data() {
		return {
			version: version,
		};
	},
};
</script>
